export default "__VITE_PUBLIC_ASSET__48e04dba__"